import React, { useState, useEffect } from "react";
// components
import { BoxContainer } from "../containers/boxContainer/boxContainer";
import CustomModal from "../customModal/CustomModal";

// actions
import {
  updateStatus,
  onlyUpdateStatus,
} from "../../store/actions/userActions";

import { connect } from "react-redux";
// styles
import styles from "./ManageMembershipOption.module.css";
import {
  PrimaryButton,
  PrimaryOutlineButton,
  SecondaryButton,
} from "../buttons/buttons";

//  utils
import { STATUSES } from "../../serverVariables/statuses";
import { logout } from "../../store/actions/authActions";
const STATUS_OPTIONS = [
  { value: STATUSES.active_not_coached, label: "Active" },
  { value: STATUSES.active_coached, label: "Active – coached" },
  { value: STATUSES.opted_out, label: "Opt Out" },
];

const ManageMembershipOptions = ({
  user,
  onClose,
  updateStatus,
  onlyUpdateStatus,
  logout
}) => {
  const isRetail = user.organization.sales_channel === "retail";
  const isClinical = user.organization.sales_channel === "clinical";
  const isClub = user.organization.sales_channel === "club";
  const isCorporate = user.organization.sales_channel === "corporate";

  // if retail → show all three; otherwise only Opt-Out
  const availableOptions = isRetail
    ? STATUS_OPTIONS
    : STATUS_OPTIONS.filter((opt) => opt.value === STATUSES.opted_out);

  const [selectedOption, setSelectedOption] = useState(
    STATUS_OPTIONS.find(
      (statusOption) => statusOption.value === user.user_status_id
    ) || STATUS_OPTIONS[0]
  );
  const [customMessage, setCustomMessage] = useState(
    () => user.organization.opt_out_message || ""
  );

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [resultModal, setResultModal] = useState({
    show: false,
    title: "",
    message: "",
    isError: false,
  });

  const defaultOptOutMessage = `
  Upon opting out, you will be logged out of your Treo account. 
  You have a 90-day period following your opt-out date to reactivate your account by logging back in. 
  If you do not log in within this 90-day timeframe, your data will be permanently removed from our system. 
  Should you wish to use Treo services again after this period, you will need to create a new account.
`;


function logOutUser() {
  try {
      logout()
          .then(() => window.location.assign('/'));
  } catch(e) {
      console.log(e);
  }
}
  useEffect(() => {
    const matchingStatusOption = STATUS_OPTIONS.find(
      (statusOption) => statusOption.value === user.user_status_id
    );

    if (matchingStatusOption) {
      setSelectedOption(matchingStatusOption);
    }
  }, [user.user_status_id]);

  useEffect(() => {
    if (user.organization.opt_out_message) {
      setCustomMessage(user.organization.opt_out_message);
    }
  }, [user.organization.opt_out_message]);

  const handleStatusOptionChange = (changeEvent) => {
    const selectedValue = Number(changeEvent.target.value);
    const matchingOption = STATUS_OPTIONS.find(
      (statusOption) => statusOption.value === selectedValue
    );

    if (matchingOption) {
      setSelectedOption(matchingOption);
    }
  };
  const handleSubmit = async () => {
    setConfirmOpen(false);
    setIsSubmitting(true);

    try {
      if (selectedOption.value === STATUSES.opted_out) {
        const response = await onlyUpdateStatus(
          user.username,
          selectedOption.value
        );
        logOutUser()
        return;
      }
      const response = await updateStatus(user.username, selectedOption.value);
      setResultModal({
        show: true,
        title: "Success",
        message: `Your membership status is now ${selectedOption.label}.`,
        isError: false,
      });
    } catch (err) {
      let backendMsg;
      if (err.response && err.response.data && err.response.data.message) {
        backendMsg = err.response.data.message + ". Unable to update status.";
      } else {
        backendMsg = err.message + ". Unable to update status.";
      }
      setResultModal({
        show: true,
        title: "Update Failed",
        message: backendMsg,
        isError: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSaveClick = () => {
    setConfirmOpen(true);
  };

  const closeResultModal = () => {
    const wasError = resultModal.isError;
    setResultModal((previousModalState) => ({
      ...previousModalState,
      show: false,
    }));
    if (!wasError) onClose();
  };

  return (
    <>
      <BoxContainer className={styles.card}>
        <h2 className={styles.header}>Change Membership Status</h2>
        <div className={styles.radioGroup}>
          {availableOptions.map(({ value, label }) => (
            <React.Fragment key={value}>
              <label className={styles.radioLabel}>
                <input
                  type="radio"
                  name="memberStatus"
                  value={value}
                  checked={selectedOption.value === value}
                  onChange={handleStatusOptionChange}
                  className={styles.radioInput}
                />
                <span
                  className={`
                    ${styles.radioPlaceholder}
                    ${selectedOption.value === value ? styles.checked : ""}
                  `}
                >
                  {selectedOption.value === value && (
                    <i className="fa fa-check" />
                  )}
                </span>
                <span className={styles.radioText}>{label}</span>
              </label>

              {value === STATUSES.opted_out && !isRetail && (
                <div className={styles.optOutMessageInline}>
                {isClub ? customMessage || defaultOptOutMessage : defaultOptOutMessage}
                </div>
              )}
            </React.Fragment>
          ))}
        </div>


        <div className={styles.manageButton}>
          <SecondaryButton onClick={onClose}>Back</SecondaryButton>
          <PrimaryButton
            className={styles.saveButton}
            onClick={handleSaveClick}
            disabled={
              isSubmitting ||
              selectedOption.value === user.user_status_id
            }
          >
            {isSubmitting ? "Saving..." : "Save"}
          </PrimaryButton>
        </div>
      </BoxContainer>

      {/* Confirmation Modal (for all status changes) */}
      <CustomModal
        show={confirmOpen}
        onHide={() => setConfirmOpen(false)}
        title="Please Confirm"
        size="sm"
        actions={[
          {
            Component: PrimaryOutlineButton,
            text: "Cancel",
            onClick: () => setConfirmOpen(false),
            buttonProps: { style: { marginRight: 16 } },
          },
          {
            Component: PrimaryButton,
            text: "Submit",
            onClick: handleSubmit,
          },
        ]}
      >
        <p>
          Are you sure you want to change membership status to{" "}
          <strong>{selectedOption.label}</strong>?
        </p>

        {/* Extra warning for Opt Out */}
        {selectedOption.value === STATUSES.opted_out && (
          <p style={{ marginTop: 8, color: "#d9534f" }}>
                    {isClub ? customMessage || defaultOptOutMessage : defaultOptOutMessage}
          </p>
        )}
      </CustomModal>

      {/* Result Modal */}
      <CustomModal
        show={resultModal.show}
        onHide={closeResultModal}
        title={resultModal.title}
        size="sm"
        actions={[
          {
            text: "Close",
            Component: PrimaryButton,
            onClick: closeResultModal,
          },
        ]}
      >
        <p>{resultModal.message}</p>
      </CustomModal>
    </>
  );
};

export default connect(({ user }) => ({ user }), {
  updateStatus,
  onlyUpdateStatus,
  logout,
})(ManageMembershipOptions);
